import { render, staticRenderFns } from "./departmentmanagementtable.vue?vue&type=template&id=1dbba539&scoped=true&"
import script from "./departmentmanagementtable.vue?vue&type=script&lang=js&"
export * from "./departmentmanagementtable.vue?vue&type=script&lang=js&"
import style0 from "./departmentmanagementtable.vue?vue&type=style&index=0&id=1dbba539&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbba539",
  null
  
)

export default component.exports